import { motion } from "framer-motion";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { useLanguage } from "../context/LanguageContext";
import { ASSETS } from "../config";

export const FloatingNav = () => {
  const { theme, toggleTheme } = useTheme();
  const { lang, setLanguage, t } = useLanguage();

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b bp-border"
      style={{
        background: "color-mix(in srgb, var(--xp-surface) 80%, transparent)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
      }}
      data-testid="floating-nav"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <img
            src={ASSETS.newLogoIcon}
            alt="XPDC"
            className="h-8 w-8 object-contain"
          />
          <span className="flex flex-col leading-none">
            <span className="font-display text-lg tracking-tight">XPDC</span>
            <span className="mt-0.5 hidden font-mono-x text-[9px] uppercase tracking-[0.18em] text-muted-x sm:block">
              PT Xentra Platform Digital Cargo
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 font-mono-x text-xs uppercase tracking-[0.15em] md:flex">
          <a
            href="#countdown"
            className="text-muted-x transition-colors duration-300 hover:text-[var(--xp-primary)]"
            data-testid="nav-timeline"
          >
            [ {t.nav.timeline} ]
          </a>
          <a
            href="#evolution"
            className="text-muted-x transition-colors duration-300 hover:text-[var(--xp-primary)]"
            data-testid="nav-newface"
          >
            [ {t.nav.newFace} ]
          </a>
          <a
            href="#manifesto"
            className="text-muted-x transition-colors duration-300 hover:text-[var(--xp-primary)]"
            data-testid="nav-about"
          >
            [ {t.nav.about} ]
          </a>
        </nav>

        <div className="flex items-center gap-2">
          <div
            className="flex items-center border bp-border font-mono-x text-xs font-bold"
            data-testid="language-toggle-button"
          >
            {["id", "en"].map((l) => (
              <button
                key={l}
                onClick={() => setLanguage(l)}
                data-testid={`lang-${l}`}
                className="px-3 py-2 uppercase transition-colors duration-300"
                style={
                  lang === l
                    ? { background: "var(--xp-primary)", color: "#fff" }
                    : { color: "var(--xp-text-2)" }
                }
              >
                {l}
              </button>
            ))}
          </div>

          <button
            onClick={toggleTheme}
            data-testid="theme-toggle-button"
            aria-label="Toggle theme"
            className="flex h-9 w-9 items-center justify-center border bp-border transition-colors duration-300 hover:bg-[var(--xp-primary)] hover:text-white"
          >
            {theme === "dark" ? (
              <Sun className="h-4 w-4" />
            ) : (
              <Moon className="h-4 w-4" />
            )}
          </button>
        </div>
      </div>
    </motion.header>
  );
};
